module.exports = __webpack_public_path__ + "static/testimoniesLink-bbfd81f2df0d3f029080421987b70a7d.jpg";